<div class="overlay-medium">
  <div class="sticky-element">
    <article>
      <header class="overlay-medium__header" id="medium-header">
        <app-compare-header (closed)="onClose($event)"></app-compare-header>
      </header>
      <section class="overlay-medium__comparisons">
        <div class="content">
          <app-compare-cards
            [comparisons]="comparisons"
            [mdOverlay]="true"
            (removed)="onRemove($event)"
          >
          </app-compare-cards>
        </div>
      </section>

      <div class="cta flex justify--center align--center">
        <dgx-components-button variant="primary" (clicked)="onCompare()"
          >Compare now</dgx-components-button
        >
      </div>
    </article>
  </div>
</div>
